export default "__VITE_ASSET__BmpFoiev__"